module.exports = __webpack_public_path__ + "static/app3-09a91d5ab64b253640d4a3c13b14e9f9.png";